import { observable, action } from 'mobx';

class User {
	@observable userInfo: IUserInfo = {
		token: '',
		uid: '',
		phone: '',
		photoUrl: '',
		realName: '',
		gender: 0,
		unitId: '',
		unitName: '',
	};

	@action
	setUserInfo = (userInfo: IUserInfo) => {
		this.userInfo = userInfo;
	};
}

interface IUserInfo {
	token: string,
	uid: string,
	phone: string,
	realName: string,
	photoUrl?: string,
	gender?: number,
	unitId?: string,
	unitName?: string
	loginFromUC?: boolean;
}

export default new User();
